import React from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom"
import AuthRouter from './routers/AuthRouter'
import AuthProvider from './context/auth/AuthProvider'
import PrivateAdminRouter from './routers/PrivateAdminRouter'
import AdminRouter from './routers/AdminRouter'
import PrivateClientRouter from './routers/PrivateClientRouter'
import ClientRouter from './routers/ClientRouter'
import PrivateKitchenRouter from './routers/PrivateKitchenRouter'
import KitchenRouter from './routers/KitchenRouter'
import OrderResult from './pages/order/OrderResult'

export default function App() {
	return (
		<>
			<BrowserRouter>
				<AuthProvider>				
				<Routes>
					<Route path="/admin/*" element={ <PrivateAdminRouter><AdminRouter /></PrivateAdminRouter>} />
					<Route path="/client/*" element={ <PrivateClientRouter><ClientRouter /></PrivateClientRouter>} />
					<Route path="/kitchen/*" element={ <PrivateKitchenRouter><KitchenRouter /></PrivateKitchenRouter>} />
					<Route path="/order/result/:orderId" element={<OrderResult />}/>
					<Route path="*" element={<AuthRouter />}/>
				</Routes>
				</AuthProvider>
			</BrowserRouter>
		</>
	)
}
